const storeData = {
  "Gujarat": {
    "Ahmedabad": [
      {
        "name": "REGAL SHOES (ABA)",
        "address": "Shop No F-17, First Floor, Nexus Ahmedabad One, T.P Scheme-1, Plot No-216, Vastrapur, Ahmedabad - 380054.",
        "type": "Alpha Mall-Ahmedabad",
        "phone": "0794-9385728",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/jyVET15t895MHRLC7"
      },
      {
        "name": "REGAL SHOES (ABN)",
        "address": "Aniket, G-1, C.G. Road, Navrangpura, Ahmedabad - 380009.",
        "type": "C.G. Road-Ahemdabad",
        "phone": "079-48002715",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/8NNVgKdfBt2YJv85A"
      },
      {
        "name": "REGAL SHOES (ABP)",
        "address": "Unit No. S-51, 2nd Floor, Palladium Ahmedabad, S.G. Highway Thaltej, Ahmedabad - 380054.",
        "type": "Palladium Mall-Ahemdabad",
        "phone": "079-69243630",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/L8LdzypqbyuwtRFY9"
      }
    ],
    "Vadodara": [
      {
        "name": "ROCIA SHOES (BRA)",
        "address": "GF-3/4, Niharika Complex, R.C. Dutt Road, Alkapuri, Vadodara – 390007.",
        "type": "Alkapuri-Vadodara",
        "phone": "0265-2990086",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/NDPPsucuz2PF9dpY8"
      },
      {
        "name": "ROCIA SHOES (BRD)",
        "address": "Shop No.GF.20,21,41 & 42, Trident, Race Course Circle, Alkapuri, Vadodara - 390007.",
        "type": "Race Course Circle-Vadodara",
        "phone": "0265-8952715",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/X9NqyBnzrQZfzuyc9"
      },
      {
        "name": "ROCIA SHOES (BRO)",
        "address": "Unit No F-16, First Floor, Inorbit Mall, Alembic Road, Subhanpura, Vadodara - 390003.",
        "type": "IInorbit Mall-Vadodara",
        "phone": "0265-4007786",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/6Fp3JQ7Tt8bTtU5bA"
      }
    ],
    "Rajkot": [
      {
        "name": "REGAL SHOES (RJK)",
        "address": "Shop No 1 & 2, Pramukh Swami Arcade, Malaviya Chowk, Rakjot - 360001.",
        "type": "Malaviya Chowk-Rajkot",
        "phone": "0281-2990161",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/25L5gx7UaaiMpWma6"
      },
      {
        "name": "REGAL SHOES (RJP)",
        "address": "Shop No. 1, Ground Floor, Perfect Point, Opp. Ramkrishna Ashram, Dr. Yagnik Road, Rajkot – 360 001, Gujarat",
        "type": "Dr. Yagnik Road-Rajkot",
        "phone": "8980132792",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/Xp799vgq2CN9AHJs9"
      }
    ],
    "Surat": [
      {
        "name": "REGAL SHOES (SRA)",
        "address": "GF 1, Manav Mandir, Parle Point, Dumaas Road, Surat - 395007.",
        "type": "Parle Point-Surat",
        "phone": "0261-3545371",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/GQehWYKUa6V1ZUuXA"
      }
    ],
    "Anand": [
      {
        "name": "ROCIA SHOES (ADV)",
        "address": "Ground & First Floor, Shop No-07 & 107, Om Elite, Anand-Vidyanagar Road, Vivekanand Wadi, Anand, Gujarat, 388001",
        "type": "Anand-Gujarat",
        "phone": "0269-2233771",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": ""
      }
    ]
  },

  "Maharashtra": {
    "Mumbai": [
      {
        "name": "REGAL SHOES (RDR)",
        "address": "8/4 Empress Mahal, Khodadad Circle, Dadar T.T, Mumbai - 400014.",
        "type": "T.T Circle-Dadar",
        "phone": "9987732329",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/uGU5xwMBr8rkZ6qe9"
      },
      {
        "name": "REGAL SHOES (RLK)",
        "address": "Jai Mahal, linking Road, Khar (w), Mumbai - 400052.",
        "type": "Linking Road-Bandra",
        "phone": "9987603562",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/B9fFYhF9k1RDAZWW7"
      },
      {
        "name": "REGAL SHOES (RML)",
        "address": "Shop No 4/5, Shree Shopping Centre, S.V.Road, Malad (w), Mumbai - 400064.",
        "type": "S. V. Road-Malad",
        "phone": "8433766681",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/c4KU9UxHzsEHYb1x9"
      },
      {
        "name": "REGAL SHOES (RMO)",
        "address": "F-30/42, First Floor, Inorbit Mall, Link Road, Malad (w), Mumbai - 400064.",
        "type": "Inorbit Mall-Malad",
        "phone": "9870019729",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/zobeCjkmFAMLQ2Hy9"
      },
      {
        "name": "REGAL SHOES (ROB)",
        "address": "Unit No. F-29, 1st Floor, Oberoi Mall, Goregaon East, Mumbai - 400063.",
        "type": "Oberoi Mall-Goregaon",
        "phone": "9137197234",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/xfz5TjtfZWaePsx36"
      },
      {
        "name": "REGAL SHOES (BOB)",
        "address": "Second Floor, Unit No.S-59A, S-60, Sky City Mall, Borivali, Mumbai - 400066.",
        "type": "Sky City Mall-Borivali",
        "phone": "836-9327987",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/1wLrcGcjg7hCqh5x8"
      },
      {
        "name": "REGAL SHOES (THV)",
        "address": "Viviana Mall, Pokhran Road No 2, Thane (W) - 400606.",
        "type": "Lake Shore Mall-Thane",
        "phone": "022-61701077",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/6c7kTwkhqdW4LmCq9"
      },
      {
        "name": "REGAL SHOES (VSW)",
        "address": "Unit No. F-24, Sector 40, Seawood Railway Station, Navi Mumbai - 400706.",
        "type": "Seawood Mall",
        "phone": "8108603312",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/AgBn7Rk4NbAtzJDHA"
      },
      {
        "name": "REGAL SHOES (VSI)",
        "address": "2nd Floor, Inorbit Mall Vashi, Navi Mumbai - 400705.",
        "type": "Inorbit Mall-Vashi",
        "phone": "9326992645",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/fVDE8P1kKtsAMkUN7"
      }
    ],

    "Pune": [
      {
        "name": "REGAL SHOES (PEL)",
        "address": "Shop No. FF-9, First Floor, Elpro City Square, Pimpri Chinchwad, Pune - 411033.",
        "type": "Elpro City Square Mall-Pune",
        "phone": "020-61327064",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": ""
      },
      {
        "name": "REGAL SHOES (PMP)",
        "address": "Shop No 7, Ground Floor, Premier Plaza Mall, Pimpari, Pune - 411019.",
        "type": "Premier Plaza  Mall-Pune",
        "phone": "020-45078173",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/ZYk97x26NgfVX7PH8"
      },
      {
        "name": "REGAL SHOES (PNW)",
        "address": "Unit No. Gs-04 B, Ground Floor, South Westend Mall, Aundh, Pune - 411007.",
        "type": "Westend Mall-Pune",
        "phone": "7066311488",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/aFGtPpUXTK5GRowz6"
      },
      {
        "name": "REGAL SHOES (RPN)",
        "address": "302, M.G. Road, Pune - 411001.",
        "type": "M. G. Road-Pune",
        "phone": "8329715895",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/gDJTZWeidpq1sVep8"
      }
    ],

    "Navi Mumbai": [
      {
        "name": "REGAL SHOES (VSW)",
        "address": "Unit No. F-24, Sector 40, Seawood Railway Station, Navi Mumbai - 400706.",
        "type": "Seawood Mall",
        "phone": "8108603312",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/AgBn7Rk4NbAtzJDHA"
      },
      {
        "name": "REGAL SHOES (VSI)",
        "address": "2nd Floor, Inorbit Mall Vashi, Navi Mumbai - 400705.",
        "type": "Inorbit Mall-Vashi",
        "phone": "9326992645",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/fVDE8P1kKtsAMkUN7"
      }
    ],

    "Aurangabad": [
      {
        "name": "REGAL SHOES (AUR)",
        "address": "Shop No. 7, 8, 9 & 10, Nirala Bazar, Aurangabad - 431001.",
        "type": "Nirala Bazar-Aurangabad",
        "phone": "0240-2990015",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/JRpfWidekGG5L8iBA"
      }
    ],

    "Nagpur": [
      {
        "name": "REGAL SHOES (NGP)",
        "address": "West High Court Road, Dharampeth, Nagpur - 440010.",
        "type": "Dharampeth-Nagpur",
        "phone": "0712-2550255",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/N2ufV5sNehzmmGd17"
      }
    ],

    "Nashik": [
      {
        "name": "REGAL SHOES (NSK)",
        "address": "Shraddha Mall, College Road, Nashik - 422005.",
        "type": "College Road-Nashik",
        "phone": "0253-4021885",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/4R5DaDGm7QMwej7WA"
      }
    ],

    "Thane": [
      {
        "name": "REGAL SHOES (THV)",
        "address": "Viviana Mall, Pokhran Road No 2, Thane (W) - 400606.",
        "type": "Lake Shore Mall-Thane",
        "phone": "022-61701077",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/6c7kTwkhqdW4LmCq9"
      }
    ]
  },

  "Odisha": {
    "Bhubneshwar": [
      {
        "name": "REGAL SHOES (BBN)",
        "address": "Esplanade By Forum, Nexus Mall, Bhubneshwar - 751010.",
        "type": "Esplanade Nexus Mall-Bhubneshwar",
        "phone": "9123795055",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/viP1Z5JtAm7hiD3bA"
      }
    ]
  },

  "Karnataka": {
    "Bangalore": [
      {
        "name": "ROCIA SHOES (BGM)",
        "address": "Mantri Mall, Malleswaram, Bengaluru - 560003.",
        "type": "Mantri Mall-Bengaluru",
        "phone": "9748291574",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/9EJpoN5aDxuFZYU77"
      }
    ]
  },

  "Tamil Nadu": {
    "Chennai": [
      {
        "name": "ROCIA SHOES (CHV)",
        "address": "VR Chennai Mall, Anna Nagar, Chennai - 600040.",
        "type": "VR Mall-Chennai",
        "phone": "9007266502",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": ""
      }
    ]
  },

  "Punjab": {
    "Patiala": [
      {
        "name": "ROCIA SHOES (PTL)",
        "address": "Bhupindra Road, Patiala - 147001",
        "type": "Bhupindar Road-Patiala",
        "phone": "0175-5016786",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/dbzvKRrS9Si4XVxT8"
      }
    ]
  },

  "Rajasthan": {
    "Jodhpur": [
      {
        "name": "REGAL SHOES (JDP)",
        "address": "Sardarpura, Jodhpur - 342003.",
        "type": "Sardarpura-Jodhpur",
        "phone": "0291-2640134",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/78rooGXzcCu7XwgBA"
      }
    ]
  },

  "Madhya Pradesh": {
    "Indore": [
      {
        "name": "REGAL SHOES (IND)",
        "address": "Next Treasure Island Mall, Indore - 452001.",
        "type": "Treasure Island Next-Indore",
        "phone": "0731-4612579",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/pb8ToQE5ho8QdT669"
      }
    ]
  },

  "Kerala": {
    "Kochi": [
      {
        "name": "ROCIA SHOES (KCF)",
        "address": "Forum Thomsun Mall, Kochi - 682304.",
        "type": "Forum Thomsun Mall-Kochi",
        "phone": "9773753543",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/pHbyBRnREyiSG6dh7"
      }
    ]
  },

  "Telangana": {
    "Hyderabad": [
      {
        "name": "ROCIA SHOES (HYN)",
        "address": "Nexus Hyderabad Mall, Kukatpally, Hyderabad - 500085.",
        "type": "Nexus Mall-Hyderabad",
        "phone": "0181-4083164",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": ""
      },
      {
        "name": "ROCIA SHOES (HYL)",
        "address": "Lakeshore Mall, Kukatpally, Hyderabad - 500072.",
        "type": "Y Junction-Hyderabad",
        "phone": "751-7788758",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": ""
      }
    ]
  },

  "Chhattisgarh": {
    "Raipur": [
      {
        "name": "ROCIA SHOES (RPZ)",
        "address": "ZORA Mall, Jora, Raipur - 492012.",
        "type": "Zora Mall-Raipur",
        "phone": "7020793149",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": ""
      }
    ]
  },

  "Chandigarh": {
    "Chandigarh": [
      {
        "name": "ROCIA SHOES (CDH)",
        "address": "Nexus Elante Mall, Phase-I, Chandigarh - 160002.",
        "type": "Nexus Elante Mall-Chandigarh",
        "phone": "0172-5080110",
        "timings": "Mon - Sun (11:00AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/HXCzBwW3KHkPrPva6"
      },
      {
        "name": "ROCIA SHOES (CDS)",
        "address": "Sector 17-C, Chandigarh - 160017.",
        "type": "Sector 17/C-Chandigarh",
         "phone": "0712-5072462",
        "timings": "Mon - Sun (10:30AM - 10:00PM)",
        "link": "https://maps.app.goo.gl/UP9aLTnR2mFyfc5x6"
      }
    ]
  }
}

document.addEventListener("DOMContentLoaded", function() {
  const stateDropdown = document.getElementById("stateDropdown");
  const cityDropdown = document.getElementById("cityDropdown");
  const storeGrid = document.getElementById("storeGrid");

  // Populate states
  for (let state in storeData) {
    const option = document.createElement("option");
    option.value = state;
    option.textContent = state;
    stateDropdown.appendChild(option);
  }

  // On state change
  stateDropdown.addEventListener("change", function() {
    cityDropdown.innerHTML = '<option value="">Select City</option>';
    storeGrid.innerHTML = "";
    const selectedState = this.value;
    if (selectedState) {
      const cities = Object.keys(storeData[selectedState]);
      cities.forEach(city => {
        const option = document.createElement("option");
        option.value = city;
        option.textContent = city;
        cityDropdown.appendChild(option);
      });
    }
  });

  // On city change
  cityDropdown.addEventListener("change", function() {
    storeGrid.innerHTML = "";
    const selectedState = stateDropdown.value;
    const selectedCity = this.value;
    if (selectedState && selectedCity) {
      const stores = storeData[selectedState][selectedCity];
      stores.forEach(store => {
        const card = document.createElement("div");
        card.className = "store-card";
        card.innerHTML = `
          <h3>${store.name}</h3>
          <p><strong>Location:</strong> ${store.type}</p>
          <p><strong>📍 Address:</strong> ${store.address}</p>
          <p><strong>📞 Phone:</strong><a href="tel: ${store.phone}"> ${store.phone}</a></p>
          <p><strong>⏰ Timings:</strong> ${store.timings}</p>
          <div class="button-container">
            <button onclick="window.open('${store.link}', '_blank')">Get Directions</button>
          </div>
        `;
        storeGrid.appendChild(card);
      });
    }
  });
});
